import React, { useImperativeHandle, useState } from 'react';
import { Box } from '@mui/material';
import dayjs from 'dayjs';
import {
  DefaultDateInput,
  DefaultSingleSelector,
  PeriodDates,
} from 'src/components';

import { SectionHeader } from ".";

const periods = [
  {
    id: '0',
    label: '1 month',
  },
  {
    id: '1',
    label: '1 year',
  },
  {
    id: '2',
    label: '2 years',
  },
];

interface RulesSectionProps {
  label?: string;
  period?: PeriodDates;
  selectorId?: string;
  onChangeRules?: (newValue:string) => void;
  onChangeRulesSelector?: (newValue:any) => void;
}

export const RulesSection = React.forwardRef(
  ({ label, period, selectorId, onChangeRules, onChangeRulesSelector }: RulesSectionProps, ref) => {
    const periodCurrent = dayjs(period?.to).year() - dayjs(period?.from).year();
    const [periodId, setPeriodId] = useState(selectorId || `${periodCurrent}`);
    const [date, setDate] = useState(period?.from || '');
    
    const handleChangePeriod = (value: string) => {
      setPeriodId(value);
      onChangeRulesSelector?.(value)
    };

    const handleChangeDate = (newValue: any) => {
      if (newValue?.isValid()) {
        setDate(newValue);
        onChangeRules?.(newValue);
      }
    };

    useImperativeHandle(ref, () => ({
      getPeriod: () => {
        const startDate: any = date || dayjs();
        let endDate;

        // 1 year
        if (periodId === '0') {
          endDate = dayjs(startDate).add(1, 'month');
        }
        // 1 month
        else if (periodId === '1') {
          endDate = dayjs(startDate).add(1, 'year');
        }
        // 2 years
        else if (periodId === '2') {
          endDate = dayjs(startDate).add(2, 'year');
        }

        return {
          from:
            typeof startDate === 'string'
              ? startDate
              : startDate?.toISOString(),
          to: endDate?.toISOString(),
        };
      },
      getId: () => {
        return periodId;
      },
    }));

    return (
      <Box>
        {label && <SectionHeader label={label} />}
        <Box>
          {/*todo date input*/}
          <DefaultDateInput
            initialValue={date}
            onChanged={handleChangeDate}
            label="Start date"
          />
          <DefaultSingleSelector
            value={periodId}
            valuesToSelect={periods}
            onChanged={handleChangePeriod}
            title="Period"
            leftContainerStyle={{
              borderTopLeftRadius: '0px',
              borderTop: 'none',
            }}
            rightContainerStyle={{
              borderTopRightRadius: '0px',
              borderTop: 'none',
            }}
          />
        </Box>
      </Box>
    );
  }
);
